var _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightGridImage1440(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 556,
    height: 500,
    viewBox: "0 0 556 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 42.3906,
    y1: 10.0234,
    x2: 42.3907,
    y2: 499.999,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.0078,
    y1: 2.17535e-8,
    x2: 84.0078,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.633,
    y1: 2.17535e-8,
    x2: 125.633,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.258,
    y1: 2.17535e-8,
    x2: 167.258,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.875,
    y1: 2.17535e-8,
    x2: 208.875,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.5,
    y1: 2.17535e-8,
    x2: 250.5,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.125,
    y1: 2.17535e-8,
    x2: 292.125,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.742,
    y1: 2.17535e-8,
    x2: 333.742,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.367,
    y1: 2.17535e-8,
    x2: 375.367,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.992,
    y1: 2.17535e-8,
    x2: 416.992,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.609,
    y1: 2.17535e-8,
    x2: 458.609,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 39.75,
    x2: -4.34612e-8,
    y2: 39.75,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 81.6133,
    x2: -4.34612e-8,
    y2: 81.6132,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 123.477,
    x2: -4.34612e-8,
    y2: 123.477,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 165.336,
    x2: -4.34612e-8,
    y2: 165.336,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 207.199,
    x2: -4.34612e-8,
    y2: 207.199,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 249.062,
    x2: -4.34612e-8,
    y2: 249.062,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 290.922,
    x2: -4.34612e-8,
    y2: 290.922,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 332.785,
    x2: -4.34612e-8,
    y2: 332.785,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 374.648,
    x2: -4.34612e-8,
    y2: 374.648,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 416.508,
    x2: -4.34612e-8,
    y2: 416.508,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 458.371,
    x2: -4.34612e-8,
    y2: 458.371,
    stroke: "#7551FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 321.024,
    cy: 355.781,
    r: 1.78137,
    fill: "#7551FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1359_22772)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 411.082,
    cy: 195.677,
    rx: 65.3076,
    ry: 138.564,
    transform: "rotate(-135 411.082 195.677)",
    fill: "url(#paint0_linear_1359_22772)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1359_22772",
    x: 300.937,
    y: 85.5312,
    width: 220.289,
    height: 220.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.902389,
    result: "effect1_foregroundBlur_1359_22772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1359_22772",
    x1: 353.678,
    y1: 106.912,
    x2: 493.95,
    y2: 242.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF9FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGridImage1440);
export default __webpack_public_path__ + "static/media/RightGridImage1440.9205c09750a316236d9b65577e2a68b3.svg";
export { ForwardRef as ReactComponent };